import { useQuery } from '@apollo/client';
import type { UseAccountOptionsFetch } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import { useMemo } from 'react';
import { GetOrganizationsListDocument } from '../../../graphql/query/organizations/GetOrganizationsList.generated.tsx';

export const useAccountOptionsFetch: UseAccountOptionsFetch = () => {
  const { data: { account = [] } = {}, loading, refetch } = useQuery(GetOrganizationsListDocument);

  const mapById = useMemo(
    () =>
      account.reduce((acc, account) => {
        acc[account.exchange_account_network?.uid] = { id: account.exchange_account_network?.uid, name: account.name };
        return acc;
      }, {}),
    [account]
  );

  return {
    accounts: {
      list: account,
      loading,
      mapById,
      refetch,
    },
  };
};
